export default "__VITE_ASSET__02573712__"